import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    DocumentTemplate as objectPayload,
    DocumentTemplateAddPayload as objectAddPayload,
    DocumentTemplateEditPayload as objectEditPayload,
    DocumentTemplateForm as objectForm,
} from './document-template.interface';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentTemplateService {
    private serviceName = 'DocumentTemplateService';

    private token!: string;
    private basePath = environment.interop.basePath;

    public getListDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.listDT;

    private getListUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.list;

    private oneUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.one;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.update;

    private storeUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.store;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.delete;

    public previewDocumentUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentTemplate.previewDocument;

    private functiiUserActiveUrl =
        this.basePath + environment.interop.indoc.functiiUser.list;

    private signaturesTemplateOperatorListIdsUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.signatures
            .getListIds;

    private updateSignaturesTemplateOperatorIdsUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.signatures
            .updateIds;

    private updateOrderUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.signatures
            .updateOrder;

    private updateSignTypeUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.signatures
            .updateSignType;

    private updateSignaturesUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.signatures
            .updateSignatures;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.active;

    // because cereri, we need to add special routes
    private getListIdsSignaturesDocumentGeneratUrl =
        this.basePath + environment.interop.indoc.documents.signatures.getListIds;

    private updateListIdsSignaturesDocumentGeneratUrl =
        this.basePath + environment.interop.indoc.documents.signatures.updateIds;

    private updateSignaturesDocumentGeneratUrl =
        this.basePath +
        environment.interop.indoc.documents.signatures.updateSignatures;

    private searchCategoriesUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentTemplate.filters.categoriesSearch;

    private templateById =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTemplate.templateById;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    update(data: objectEditPayload) {
        return this.http.put(this.updateUrl, data, this.httpOptions);
    }

    store(data: objectAddPayload) {
        return this.http.post(this.storeUrl, data, this.httpOptions);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    one(id: number) {
        return this.http.get(this.oneUrl + id, this.httpOptions);
    }

    getRecordsList(is_address: boolean) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getListUrl + '?' + 'is_address=' + is_address
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error(
                        'Error in get request with service ' + this.serviceName,
                        error
                    );
                    return throwError(error);
                })
            );
    }

    getFunctiiUserActiveList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.functiiUserActiveUrl
            )
            .pipe(
                map((response) => {
                    console.log(response);
                    return response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }));
                }),
                catchError((error) => {
                    console.error(
                        'Error in get request with service ' + this.serviceName,
                        error
                    );
                    return throwError(error);
                })
            );
    }

    // signaturesTemplateOperatorListIds(
    //     id: number,
    //     docType: number | undefined,
    //     manualOverride: boolean = false
    // ) {
    //     // return is simple, [1,2,3]
    //     return this.http.get(this.signaturesTemplateOperatorListIdsUrl + id + '/' + docType, this.httpOptions);
    // }

    signaturesTemplateOperatorListIds(
        id: number,
        docType: number | undefined,
        manualOverride: boolean = false
    ) {
        // return is simple, [1,2,3]

        let pathUrl =
            manualOverride == false
                ? this.signaturesTemplateOperatorListIdsUrl
                : this.getListIdsSignaturesDocumentGeneratUrl;

        return this.http.get(pathUrl + id + '/' + docType, this.httpOptions);
    }

    // updateSignaturesTemplateOperatorIds(
    //     id: number,
    //     data: any,
    //     manualOverride: boolean = false
    // ) {
    //     // basically a simple array with numbers [1,2,3]

    //     return this.http.put(this.updateSignaturesTemplateOperatorIdsUrl + id, data, this.httpOptions);
    // }

    updateSignaturesTemplateOperatorIds(
        id: number,
        data: any,
        manualOverride: boolean = false
    ) {
        // basically a simple array with numbers [1,2,3]

        let pathUrl =
            manualOverride == false
                ? this.updateSignaturesTemplateOperatorIdsUrl
                : this.updateListIdsSignaturesDocumentGeneratUrl;

        return this.http.put(pathUrl + id, data, this.httpOptions);
    }

    updateOrder(id: number, data: any) {
        // basically a simple array with numbers [1,2,3]
        return this.http.post(this.updateOrderUrl + id, data, this.httpOptions);
    }

    updateSignType(id: number, data: any) {
        return this.http.post(this.updateSignTypeUrl + id, data, this.httpOptions);
    }

    // updateSignatures(data: any, manualOverride: boolean = false) {
    //     return this.http.post(this.updateSignaturesUrl, data, this.httpOptions);
    // }
    updateSignatures(data: any, manualOverride: boolean = false) {
        let pathUrl =
            manualOverride == false
                ? this.updateSignaturesUrl
                : this.updateSignaturesDocumentGeneratUrl;
        return this.http.post(pathUrl, data, this.httpOptions);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    /**
     * Search categories for typeahead functionality
     */
    searchCategories(searchTerm: string, limit: number = 20) {
        return this.http.get(
            this.searchCategoriesUrl +
            `?search=${encodeURIComponent(searchTerm)}&limit=${limit}`,
            this.httpOptions
        );
    }

    /**
     * Get clone preview information
     */
    getClonePreview(data: { template_id: number, template_type: string }) {
        return this.http.get(
            this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentTemplate.clone.preview,
            {
                ...this.httpOptions,
                params: data
            }
        );
    }

    /**
     * Clone document template
     */
    cloneDocumentTemplate(templateId: number, data: any) {
        return this.http.post(
            this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentTemplate.clone.documentTemplate + templateId,
            data,
            this.httpOptions
        );
    }

    templateByCerereId(id: number, cerere_id: number) {
        return this.http.get(
            this.templateById + id + '/' + cerere_id,
            this.httpOptions
        );
    }

    /**
     * Get signature flow data for visualization
     * Returns enriched signature data with names for directie, compartiment, user, and functie
     */
    getSignatureFlowData(templateId: number): Observable<any> {
        const flowUrl = this.basePath + 'api/registratura/document-templates/signatures/flow/';
        return this.http.get(flowUrl + templateId, this.httpOptions);
    }

    /**
     * Get signature flow PDF export URL
     */
    getSignatureFlowPdfUrl(templateId: number): string {
        return this.basePath + 'api/registratura/document-templates/signatures/flow/' + templateId + '/pdf';
    }

    // =====================================================
    // Template Redaction Configuration Methods (like Signatures)
    // =====================================================

    // URLs for redaction template configuration
    private redactionsTemplateOperatorListIdsUrl =
        this.basePath + 'api/registratura/document-templates/redactions/list-ids/';

    private updateRedactionsTemplateOperatorIdsUrl =
        this.basePath + 'api/registratura/document-templates/redactions/update-ids/';

    private updateRedactionsUrl =
        this.basePath + 'api/registratura/document-templates/redactions/update-order';

    // URLs for document generat redaction (manual override)
    private getListIdsRedactionsDocumentGeneratUrl =
        this.basePath + 'api/registratura/document/generabile/redactions/list-ids/';

    private updateListIdsRedactionsDocumentGeneratUrl =
        this.basePath + 'api/registratura/document/generabile/redactions/update-ids/';

    private updateRedactionsDocumentGeneratUrl =
        this.basePath + 'api/registratura/document/generabile/redactions/update-order';

    /**
     * Get redaction configuration for template (like signaturesTemplateOperatorListIds)
     */
    redactionsTemplateOperatorListIds(id: number, manualOverride: boolean = false) {
        let pathUrl = manualOverride == false
            ? this.redactionsTemplateOperatorListIdsUrl
            : this.getListIdsRedactionsDocumentGeneratUrl;

        return this.http.get(pathUrl + id, this.httpOptions);
    }

    /**
     * Update redaction user_type_ids for template (like updateSignaturesTemplateOperatorIds)
     */
    updateRedactionsTemplateOperatorIds(id: number, data: any, manualOverride: boolean = false) {
        let pathUrl = manualOverride == false
            ? this.updateRedactionsTemplateOperatorIdsUrl
            : this.updateListIdsRedactionsDocumentGeneratUrl;

        return this.http.put(pathUrl + id, data, this.httpOptions);
    }

    /**
     * Update redactions order and configuration (like updateSignatures)
     */
    updateRedactions(data: any, manualOverride: boolean = false) {
        let pathUrl = manualOverride == false
            ? this.updateRedactionsUrl
            : this.updateRedactionsDocumentGeneratUrl;
        return this.http.post(pathUrl, data, this.httpOptions);
    }

    // =====================================================
    // Template Redaction Flow Methods
    // =====================================================

    /**
     * Get redaction flow data for visualization
     */
    getRedactionFlowData(templateId: number): Observable<any> {
        const flowUrl = this.basePath + 'api/registratura/document-templates/redactions/';
        return this.http.get(flowUrl + templateId, this.httpOptions);
    }

    /**
     * Reorder template redaction steps
     */
    reorderTemplateRedactions(templateId: number, orderData: { id: number; order: number }[]): Observable<any> {
        const url = this.basePath + 'api/registratura/document-templates/redactions/' + templateId + '/reorder';
        return this.http.put(url, { order: orderData }, this.httpOptions);
    }

    /**
     * Add new redaction step to template
     */
    addTemplateRedaction(templateId: number, data: { redaction_type: number; description?: string }): Observable<any> {
        const url = this.basePath + 'api/registratura/document-templates/redactions/' + templateId;
        return this.http.post(url, data, this.httpOptions);
    }

    /**
     * Update existing redaction step
     */
    updateTemplateRedaction(templateId: number, redactionId: number, data: {
        redaction_type?: number;
        description?: string;
        user_type?: number;
        directie_id?: number;
        compartiment_id?: number;
        user_id?: number;
    }): Observable<any> {
        const url = this.basePath + 'api/registratura/document-templates/redactions/' + templateId + '/' + redactionId;
        return this.http.put(url, data, this.httpOptions);
    }

    /**
     * Delete redaction step from template
     */
    deleteTemplateRedaction(templateId: number, redactionId: number): Observable<any> {
        const url = this.basePath + 'api/registratura/document-templates/redactions/' + templateId + '/' + redactionId;
        return this.http.delete(url, this.httpOptions);
    }
}
